import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Languages, Trophy } from 'lucide-react';

/**
 * Full-screen layout for login / register (no TopNav).
 */
export function AuthLayout({ children, title, subtitle }) {
  const { language, isRTL, toggleLanguage } = useLanguage();

  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center bg-zinc-50 px-4 py-12"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <button
        type="button"
        onClick={toggleLanguage}
        className={`fixed top-4 z-10 inline-flex items-center gap-2 rounded-xl border border-zinc-200 bg-white px-4 py-2 text-sm font-semibold text-zinc-700 shadow-sm transition hover:bg-zinc-50 ${isRTL ? 'left-4' : 'right-4'}`}
      >
        <Languages className="h-4 w-4 text-brand-600" />
        {language === 'en' ? 'עברית' : 'English'}
      </button>

      <div className="mb-8 flex flex-col items-center text-center">
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-600 text-white shadow-lg shadow-brand-600/25">
          <Trophy className="h-8 w-8" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-zinc-900 sm:text-3xl">{title}</h1>
        {subtitle ? <p className="mt-2 text-sm text-zinc-600 sm:text-base">{subtitle}</p> : null}
      </div>

      <div className="w-full max-w-md animate-fade-in rounded-2xl border border-zinc-200/90 bg-white p-6 shadow-md shadow-zinc-900/5 sm:p-8">
        {children}
      </div>

      <p className="mt-8 text-center text-xs text-zinc-500">
        <Link to="/login" className="font-medium text-brand-600 hover:text-brand-700">
          Football Bets
        </Link>
      </p>
    </div>
  );
}
